var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reason-list"},[_c('div',{staticClass:"reason-list__list"},_vm._l((_vm.filteredList),function(reason){return _c('div',{key:reason.id,staticClass:"reason-list__reason-item",class:{
        'reason-list__reason-item--selected': _vm.isReasonSelected(reason),
      },on:{"click":function($event){return _vm.selectReason(reason)}}},[_vm._v(" "+_vm._s(reason.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }